import { getStickyHeaderHeight } from "../components"

export const scrollToId = (id: string, offset = 0) => {
  const target = document.getElementById(id)
  if (!target) return
  target.style.setProperty(
    "scroll-margin-top",
    `${getStickyHeaderHeight() + offset}px`,
  )
  target.scrollIntoView({ behavior: "smooth" })
  // Clean up after animation (~500ms covers most smooth scroll durations)
  setTimeout(() => target.style.removeProperty("scroll-margin-top"), 500)
}
